<div [@routerTransition]>

  <!--<div class="row">
    <div class="col-md-8">
      <label class="margin-bottom-0px font-size-18px font-weight-bold">Material Consumption Group Templates</label>
    </div>
  </div>-->

  <div class="row">

    <div class="columnfeatures1 colmd3">

      <div class="card paddin-left-5px" *ngIf="ShowList">

        <div class="card-header wh-header header3 padding-right-32px padding-bottom-0px padding-left-10px">

          <div class="row margin-top10px nav-link-hand">

            <label class="wh-header padding-left-5px font-weight-normal card-title-schedule-bl border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px">
              Consumption Group
            </label>

          </div>
        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px">
          <div class="row border-top border-bottom padding-top-10px padding-bottom-10px margin-right-0px margin-left-0px">
            <div class="col-md-9">
              <search-list [title]="searchTitle" [hideTitle]="1"></search-list>
              <!--<input type="search" class="form-control padding-bottom-2px  margin-left-10px" placeholder="Search....">-->
            </div>
            <div class="col-md-2 padding-top-2px padding-left-10px">
              <button (click)="newmodal1()" type="button" class="btn btn-new btn-sm" tooltip="Add"><i class="fas fa-plus nav-link-hand"></i></button>

            </div>

          </div>
          <div>
            <div class="chatsd product-chart-wrapper product-chat-height-650 agreement-chart-wrapper scroll padding-lrt ">
              <div class="row border-bottom  rowfor margin-left-zero margin-right-0px nav-link-hand padding-all-5px" (click)="SelectedGroup(l)" *ngFor="let l of CurrentCustomCodeValuesController">
                <div class="col-md-12">
                  <div class="row height-20px margin-left-zero">

                    <a class="nav-link-hand margin-left-5px font-size-14 td-elipsis-scan">{{l.DisplayName}}</a>
                  </div>


                </div>


              </div>


            </div>
          </div>

        </div>

      </div>
    </div>



    <div class="columnconsumption2">

      <div class="card height-100vh">
        <div class="card-header wh-header  padding-bottom-0px padding-left-0px padding-right-0px padding-t-6px">
          <div class="row border-bottom padding-bottom-5px margin-left-0px margin-right-0px">
            <div class="col-md-11" *ngIf="SelectedGroupDetails">
              <label class="margin-bottom-0px margin-left-5px">Group Items of  <b> {{SelectedGroupDetails.DisplayName}} </b></label>
            </div>

            <!--<div class="col-md-1 float-right">
              <div class="row">

                <div class="col-md-6 padding-left-0px">
                  <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" (click)="SaveData()">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>

                </div>
              </div>

            </div>-->

          </div>

        </div>
        <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">

          <div class="chatsd product-chart-wrapper agreement-chart-wrapper ps2 padding-lrt height-80pe">
            <div class="row padding-top-3px">
              <div class="col-md-12">
                <div class="table-component">
                  <div class="table-responsive overflow-x">


                    <table class="table table-striped margin-left-20p table-fixed"
                           cols="auto,2*,*,*,*,*,*,*">

                      <thead class="">
                        <tr>

                          <th class="min-width-24px padding-top-4px padding-bottom-4px th-sticky">
                            #
                          </th>


                          <th class="padding-top-4px padding-bottom-4px th-sticky">
                            Item Name
                          </th>
                          <th class="padding-top-4px padding-bottom-4px th-sticky">
                            Min Qty
                          </th>

                          <th class="padding-top-4px padding-bottom-4px th-sticky">
                            Max Qty
                          </th>

                          <th class="padding-top-4px padding-bottom-4px th-sticky">
                            Remove/Edit
                          </th>

                        </tr>
                      </thead>

                      <tbody class="table-body">
                        <tr *ngFor="let l of CurrentConsumptionGroupItemsController;let i = index">


                          <td class="td-padding-tb">
                            {{i+1}}
                          </td>
                          <td class=" td-padding-tb">{{l.ItemName}}</td>

                          <td class="text-align-center td-padding-tb">
                            {{l.MinQty}}
                            <!--<input type="number" class="form-control text-align-right td-width-82px" placeholder=""
                                   id="CurrentSaveConsumptionGroupItemRequest.MinQty"
                                   [(ngModel)]="CurrentSaveConsumptionGroupItemRequest.MinQty"
                                   name="CurrentSaveConsumptionGroupItemRequest.MinQty" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                   maxlength="100" />-->
                            <!--<input type="number" class="form-control text-align-right td-width-82px" placeholder=""
                            [(ngModel)]="l.MinQty"
                            maxlength="100" />-->
                          </td>
                          <td class="text-align-center td-padding-tb">
                            {{l.MaxQty}}
                            <!--<input type="number" class="form-control text-align-right td-width-82px" placeholder=""
                                   id="CurrentSaveConsumptionGroupItemRequest.MaxQty"
                                   [(ngModel)]="CurrentSaveConsumptionGroupItemRequest.MaxQty"
                                   name="CurrentSaveConsumptionGroupItemRequest.MaxQty" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                   maxlength="100" />-->
                            <!--<input type="number" class="form-control text-align-right td-width-82px" placeholder=""
                            [(ngModel)]="l.MaxQty"
                            maxlength="100" />-->
                          </td>

                          <td class="td-padding-tb">
                            <a (click)="EditGroupItem(l)" class="nav-link-hand education-navlink" tooltip="Edit">
                              <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                            </a>
                            <!--<button type="button" (click)="EditGroupItem(l)"
                                    class="button-service-save font-size-16px color-secondary nav-link-hand margin-left-3px" title="Edit">                                    
                              <i class="fas fa-pencil-alt"></i>
                            </button>-->                            
                            <a class="nav-link-hand font-size-16px color-Rejected" title="Remove">
                              <i class="far fa-trash-alt nav-link-hand"></i>
                            </a>

                          </td>

                        </tr>
                      </tbody>



                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>

      <!--<div class="padding-right-0px background-white">
        <div class="">

          <div class="card my-profile-form top-link" *ngIf="ShowList2">
            <div class="card-header wh-header padding-bottom-6px">
              <div class="row">
                <div class="col-md-5 padding-left-10px">
                  Group Items
                </div>

              </div>

            </div>
            <div class="card-body padding-top-0px padding-left-0px">

              <div class="row">
                <div class="col-md-12 padding-left-0px">
                  <div class="table-component">
                    <div class="table-responsive">


                      <table class="table table-striped margin-left-zero my-profile-form table2">

                        <thead>
                          <tr>

                            <th class="width-35px">
                              #
                            </th>

                            <th class="">
                              Item Name
                            </th>

                            <th class="">
                              Min Qty
                            </th>

                            <th class="">
                              Max Qty
                            </th>

                            <th class="">
                              Remove/Edit
                            </th>

                          </tr>
                        </thead>

                        <tbody class="table-body">
                          <tr>

                            <td class=" td-padding-tb width-35px">1</td>
                            <td class=" td-padding-tb">Medicines</td>
                            <td class="td-padding-tb">5</td>
                            <td class=" td-padding-tb">25</td>
                            <td class=" td-padding-tb ">
                              <button (click)="EditFeat()" type="submit" class="button-service-save padding-right-15px font-size-16px color-secondary nav-link-hand margin-left-3px"><i class="fas fa-pencil-alt"></i></button>
                              <a class="nav-link-hand font-size-16px color-Rejected" title="Remove"><i class="far fa-trash-alt nav-link-hand"></i></a>
                            </td>

                          </tr>

                        </tbody>

                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>



        </div>
      </div>-->
    </div>


    <div class="columnconsumption3">


      <div class="card paddin-left-5px">

        <div class="card-header wh-header header3 padding-right-32px padding-bottom-0px padding-left-10px">

          <div class="row margin-top10px nav-link-hand">

            <label class="wh-header padding-left-5px font-weight-normal card-title-schedule-bl border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px">
              Consumption Materials
            </label>

          </div>
        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px">
          <div class="row border-top border-bottom padding-top-10px padding-bottom-10px margin-right-0px margin-left-0px">
            <div class="col-md-10">
              <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
              <!--<input type="search" class="form-control padding-bottom-2px  margin-left-10px" placeholder="Search....">-->
            </div>
            <!--<div class="col-md-2 padding-top-2px padding-left-10px">
              <button (click)="newmodal2()" type="button" class="btn btn-new btn-sm" tooltip="Add"><i class="fas fa-plus nav-link-hand"></i></button>

            </div>-->

          </div>
          <div *ngIf="!CurrentMaterialSpecsController || CurrentMaterialSpecsController.length<=0"
               class="row border-top border-bottom padding-top-10px padding-bottom-10px margin-right-0px margin-left-0px">
            <div class="col-md-10">
              Please Wait...<br />
              Loading materials List.
            </div>

          </div>
          <div>
            <div class="chatsd product-chart-wrapper product-chat-height-600 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
              <div class="table-component actor-table">

                <div class="table-responsive padding-right-11px">


                  <table class="table table-striped table2">
                    <tbody>
                      <tr *ngFor="let l of pdata">
                        <td class="td-padding-2px">

                          <div class="row margin-left-zero margin-right">
                            <div class="col-md-2  margin-tb-auto padding-right-0px padding-left-0px">
                              <button type="button"
                                      (click)="newmodal2(l)"
                                      class="btn  btn-sm plus-button " id="FileUpload"
                                      name="upload">
                                <i class="fas fa-plus font-size-11p"></i>
                              </button>
                            </div>
                            <div class="col-md-10 margin-tb-auto padding-left-0px">
                              <label class="margin-bottom-0px color3">{{l.MaterialName}}</label>

                            </div>
                          </div>


                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </div>

        </div>

      </div>


    </div>

  </div>


</div>



